var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgChatFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 32 33",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2786 3.79639C24.1318 3.79639 27.8 8.19167 26.9318 12.9665L26.5177 15.2443L28.4642 20.1107L28.8975 21.1939L27.8143 20.7606L22.9844 18.8286L20.1581 19.7707L19.9941 19.2786C19.998 19.3769 20 19.4757 20 19.575C20 24.1162 15.8872 27.5486 11.4193 26.7363L9 26.2964L4 28.2964L6 23.2964L5.56012 20.8771C4.74777 16.4091 8.18019 12.2964 12.7214 12.2964C16.4738 12.2964 19.563 15.1359 19.9575 18.7835L22.8419 17.822L23.0156 17.7641L23.1857 17.8321L27.1025 19.3989L25.5358 15.4821L25.4823 15.3485L25.5081 15.2069L25.9479 12.7876C26.7045 8.62663 23.5079 4.79639 19.2786 4.79639C15.5349 4.79639 12.5 7.83129 12.5 11.575V12.2964H11.5V11.575C11.5 7.279 14.9826 3.79639 19.2786 3.79639Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgChatFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chat-filled.9ab410bb6bb68d825b86023ec2dfc113.svg";